export default __webpack_public_path__ + "static/media/certificate_8.6b8a4ab3.jpg";